"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SCHEMA = 'iglu:com.angi.events/component_display/jsonschema/1-0-0';
/**
 * Generates the component_display event schema
 */
const componentDisplayEvent = () => {
    return {
        schema: SCHEMA,
        data: {},
    };
};
exports.default = componentDisplayEvent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50RGlzcGxheS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9kYXRhU3RydWN0dXJlcy9ldmVudHMvY29tcG9uZW50RGlzcGxheS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLE1BQU0sTUFBTSxHQUFHLHlEQUF5RCxDQUFDO0FBRXpFOztHQUVHO0FBQ0gsTUFBTSxxQkFBcUIsR0FBRyxHQUF1QixFQUFFO0lBQ25ELE9BQU87UUFDSCxNQUFNLEVBQUUsTUFBTTtRQUNkLElBQUksRUFBRSxFQUFFO0tBQ1gsQ0FBQztBQUNOLENBQUMsQ0FBQztBQUVGLGtCQUFlLHFCQUFxQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/dataStructures/events/componentDisplay.ts